import { useState, useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { useLogo, useCompanyName } from '../context/PortalDataContext';
import { useIsPillBorderRadius } from '../hooks/useIsPillBorderRadius';
import { useThemeBackground } from '../hooks/useThemeBackground';
import { usePortalNavigation } from '../hooks/usePortalNavigation';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { PortalsSideNav } from './PortalsNav';
import { MyAccountPopover } from './MyAccountPopover';
import { PortalsTopBar } from './PortalsTopBar';
import { PortalsNavDrawer } from './PortalsNavDrawer';
import { GlobalPortalStyles } from './GlobalPortalStyles';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PortalsHeader({
  logoAccessory,
  shouldShowSideNav
}) {
  var _ref, _logo$alt;
  const logo = useLogo();
  const companyName = useCompanyName();
  const borderProps = !shouldShowSideNav ? {
    borderBlockEndWidth: '100',
    borderBlockEndColor: 'fill-surface-raised',
    borderBlockEndStyle: 'solid'
  } : {};
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    alignItems: "center",
    blockSize: "56px",
    flexShrink: "0",
    paddingInlineStart: shouldShowSideNav ? '200' : '800',
    paddingInlineEnd: shouldShowSideNav ? '400' : '800'
  }, borderProps, {
    children: [/*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      alignItems: "center",
      children: logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_jsx("img", {
        src: logo.src,
        alt: (_ref = (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : logo.name) !== null && _ref !== void 0 ? _ref : 'Logo',
        style: {
          maxHeight: '40px',
          maxWidth: '150px'
        }
      }) : companyName ? /*#__PURE__*/_jsx(TruncateString, {
        maxInlineSize: "300px"
        // @ts-ignore need to set this to get font family styles
        ,
        typography: "heading-200",
        color: "text-core-default",
        "data-test-id": "portals-logo-fallback",
        children: companyName
      }) : null
    }), logoAccessory ? /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      alignItems: "center",
      children: logoAccessory
    }) : null, /*#__PURE__*/_jsx(Flex, {
      flexGrow: "1"
    }), /*#__PURE__*/_jsx(Flex, {
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(MyAccountPopover, {})
    })]
  }));
}
export function PortalsAppLayout({
  children,
  logoAccessory: logoAccessoryProp,
  headerStart,
  history,
  currentPathname
}) {
  const logoAccessory = logoAccessoryProp !== null && logoAccessoryProp !== void 0 ? logoAccessoryProp : headerStart;
  const isPill = useIsPillBorderRadius();
  const {
    shouldShowSideNav
  } = usePortalNavigation(currentPathname);
  const {
    shell,
    mainContentArea
  } = useThemeBackground();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === 'mobile';
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openDrawer = useCallback(() => setIsDrawerOpen(true), []);
  const closeDrawer = useCallback(() => setIsDrawerOpen(false), []);
  const navBackgroundColor = shouldShowSideNav ? shell : mainContentArea;
  const shouldShowDesktopSideNav = !isMobile && shouldShowSideNav;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    blockSize: "100vh",
    overflow: "hidden",
    backgroundColor: navBackgroundColor,
    children: [/*#__PURE__*/_jsx(GlobalPortalStyles, {}), isMobile ? /*#__PURE__*/_jsx(PortalsTopBar, {
      onHamburgerClick: openDrawer,
      isDrawerOpen: isDrawerOpen,
      shouldShowSideNav: shouldShowSideNav,
      logoAccessory: logoAccessory,
      navBackgroundColor: navBackgroundColor
    }) : /*#__PURE__*/_jsx(PortalsHeader, {
      logoAccessory: logoAccessory,
      shouldShowSideNav: shouldShowSideNav
    }), /*#__PURE__*/_jsxs(Flex, {
      flexGrow: "1",
      overflow: "hidden",
      minBlockSize: "0px",
      children: [shouldShowDesktopSideNav && /*#__PURE__*/_jsx(View, {
        inlineSize: "56px",
        flexShrink: 0,
        paddingBlock: "400",
        children: /*#__PURE__*/_jsx(PortalsSideNav, {
          history: history,
          currentPathname: currentPathname
        })
      }), /*#__PURE__*/_jsx(View, {
        as: "main",
        flexGrow: "1",
        backgroundColor: mainContentArea,
        minInlineSize: "0px",
        borderStartStartRadius: shouldShowDesktopSideNav ? isPill ? '0' : '400' : undefined,
        overflow: "auto",
        children: children
      }, "portal-main")]
    }), isMobile && shouldShowSideNav ? /*#__PURE__*/_jsx(PortalsNavDrawer, {
      open: isDrawerOpen,
      onClose: closeDrawer,
      history: history,
      currentPathname: currentPathname
    }) : null]
  });
}